import { combineReducers } from "redux";

import user from "./user";
import menu from "./menu";

export default combineReducers({
  user,
  menu
});
